import { createContext, type Context } from 'react';

import type { useDynamicSplitButtonCatchupLastViewedTimeQuery$variables } from './__generated__/useDynamicSplitButtonCatchupLastViewedTimeQuery.graphql.ts';
import type { useDynamicSplitButton_catchupLastViewedTimeReader$data } from './__generated__/useDynamicSplitButton_catchupLastViewedTimeReader.graphql.ts';

type Value =
	| (useDynamicSplitButtonCatchupLastViewedTimeQuery$variables & {
			data: useDynamicSplitButton_catchupLastViewedTimeReader$data | null;
	  })
	| undefined;
export const CatchupPersonalizationContext: Context<Value> = createContext<Value>(undefined);
